<template>
  <!-- 虚拟号详情 -->
  <div class="Customer">
    <el-card>
      <el-form
        :inline="true"
        :model="searchObj"
        class="demo-form-inline"
        size="mini"
      >
        <el-form-item label="经销商代码/名称">
          <el-input
            v-model="searchObj.name"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="虚拟号码">
          <el-input
            v-model="searchObj.phone"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="searchObj.timer"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="handelFun('search')"
            >查 询</el-button
          >

          <el-button
            type="primary"
            icon="el-icon-download"
            @click="handelFun('download')"
            >导 出</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        style="width: 100%"
        size="mini"
        border
        v-loading="loading"
      >
        <el-table-column prop="AgencyID" label="经销商代码"> </el-table-column>
        <el-table-column prop="AgencyName" label="经销商名称"></el-table-column>
        <el-table-column prop="VirtualNum" label="虚拟号码"> </el-table-column>
        <el-table-column prop="longTime" label="通话时长"> </el-table-column>
        <el-table-column prop="cost" label="通话费用">
          <template slot-scope="scope">
            {{ (scope.row.cost * 100) / 100 }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="address" label="月租费用"> </el-table-column> -->
        <el-table-column prop="area" label="号码归属地"> </el-table-column>
        <el-table-column prop="bdphone" label="绑定号码"> </el-table-column>
        <el-table-column prop="bdname" label="绑定员工"> </el-table-column>
        <el-table-column prop="CreatedDate" label="导入时间"> </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { exportExcel } from "../../utils/DownLoadFail.js"; //下载表格
import {
  formatDate,
  getMonthDays,
  getWeekStartDate,
  getMonthEndDate,
  getMonthStartDate,
  getWeekEndDate
} from "../../utils/Date.js";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: {
        total: 0,
        pageIndex: 1, // 页面
        pageSize: 10 // 条数
      },
      searchObj: {
        phone: "",
        name: "",
        timer: [
          new Date(new Date().getTime()).Format("YYYY-MM-DD"),
          new Date(new Date().getTime()).Format("YYYY-MM-DD")
        ]
      }
    };
  },
  methods: {
    // 分页
    currentChange(e) {
      this.pagination.pageIndex = e;
      this.getDataDetaiList();
    },
    // 方法类
    handelFun(type) {
      switch (type) {
        case "search":
          console.log("查询");
          this.pagination.pageIndex = 1;
          this.getDataDetaiList();
          break;
        case "download":
          console.log("下载");
          this.getDataDetaiList("download");

          // exportExcel("表头", "对应字段", "数据", "下载文件名");
          break;

        default:
          break;
      }
    },
    // 获取时长
    GetTimeLong(time) {
      let timer = time;
      let hh = Math.floor(timer / 60 / 60);
      let mm = Math.floor((timer - hh * 3600) / 60);
      let ss = Math.floor(timer - (hh * 60 + mm) * 60);
      return {
        hh,
        mm,
        ss
      };
    },
    // 获取数据
    getDataDetaiList(type) {
      this.loading = true;
      let formdata = new FormData();
      formdata.append("action", "getVirtualNumlistZb");
      formdata.append(
        "pageno",
        type == "download" ? "" : this.pagination.pageIndex
      );
      formdata.append("pagesize", this.pagination.pageSize);
      formdata.append("VirtualNum", this.searchObj.phone);
      formdata.append("dealercode", this.searchObj.name);
      formdata.append("t0", this.searchObj.timer[0]);
      formdata.append("t1", this.searchObj.timer[1]);
      this.$axios
        .formatPostData("manage/SetInData.aspx", formdata)
        .then(res => {
          console.log(res);
          if (res.data.errcode == 0) {
            this.loading = false;
            res.data.list.forEach(element => {
              let timer = this.GetTimeLong(element.calllongtime);
              element.longTime = `${timer.hh}:${timer.mm}:${timer.ss}`;
            });
            if (type == "download") {
              let TABLEHEARD = [
                "经销商代码",
                "经销商名称",
                "虚拟号码",
                "通话时长",
                "通话费用",
                "号码归属地",
                "绑定号码",
                "绑定员工",
                "导入时间"
              ];
              let TABLEHEADFILE = [
                "AgencyID",
                "AgencyName",
                "VirtualNum",
                "longTime",
                "cost",
                "area",
                "bdphone",
                "bdname",
                "CreatedDate"
              ];
              let name = "虚拟号详情";
              exportExcel(TABLEHEARD, TABLEHEADFILE, res.data.list, name);
            } else {
              this.tableData = res.data.list;
              this.pagination.total = res.data.rowCount * 1;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    }
  },
  mounted() {
    this.getDataDetaiList();
  }
};
</script>

<style scoped>
.pagination {
  margin-top: 10px;
  text-align: right;
}
</style>
